import config from 'config'
import { hasLoyalty } from '../services/ConfigService'

export default {
    beforeCreate () {
        this.isLoyaltyPartner = hasLoyalty(config)
    },
    methods: {
        formatPoints (pointsAmount, pointsCurrencyOverride) {
            const format = (this.$store.state.loyalty || {}).currency_formatter || ''
            const currency = typeof pointsCurrencyOverride === 'string' ? pointsCurrencyOverride : (this.$store.state.loyalty || {}).currency_label || ''
            return `${this.$formatNumeral(pointsAmount, format)}${currency ? ' ' : ''}${currency}`
        },
        formatPointsOnly (pointsAmount) {
            const format = (this.$store.state.loyalty || {}).currency_formatter || ''
            return `${this.$formatNumeral(pointsAmount, format)}`
        }
    }
}
